import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";



// Async Thunks
// Accepts propertyId (number) or { propertyId, page?, per_page? } for pagination
export const fetchUnitsByProperty = createAsyncThunk(
  "unit/fetchUnitsByProperty",
  async (arg) => {
    const propertyId = typeof arg === "object" ? arg.propertyId : arg;
    const page = typeof arg === "object" ? arg.page ?? 1 : 1;
    const per_page = typeof arg === "object" ? arg.per_page ?? 10 : 10;

    const response = await api.get("/api/units", {
      params: { property_id: propertyId, page, per_page },
    });
    const data = response.data;
    return {
      propertyId,
      units: Array.isArray(data?.unit) ? data.unit : [],
      current_page: data?.current_page ?? 1,
      last_page: data?.last_page ?? 1,
      total: data?.total ?? 0,
    };
  }
);

export const addUnit = createAsyncThunk(
  "unit/addUnit",
  async ({ propertyId, data }) => {
    const res = await api.post(`/api/units`, data);
    return { propertyId, unit: res.data };
  }
);

export const updateUnit = createAsyncThunk(
  "unit/updateUnit",
  async ({ id, data }) => {
    const res = await api.put(`/api/units/${id}`, data);
    return res.data;
  }
);

export const deleteUnit = createAsyncThunk(
  "unit/deleteUnit",
  async ({ propertyId, id }) => {
    await api.delete(`/api/units/${id}`);
    return { propertyId, id };
  }
);

// Slice
const unitSlice = createSlice({
  name: "unit",
  initialState: {
    byProperty: {}, // { [propertyId]: [units] }
    paginationByProperty: {}, // { [propertyId]: { current_page, last_page, total } }
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
    .addCase(fetchUnitsByProperty.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchUnitsByProperty.fulfilled, (state, action) => {
        const { propertyId, units, current_page, last_page, total } = action.payload;
        state.byProperty[propertyId] = units;
        state.paginationByProperty[propertyId] = {
          current_page,
          last_page,
          total,
        };
        state.status = "succeeded";
      })
      .addCase(fetchUnitsByProperty.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(addUnit.fulfilled, (state, action) => {
        const { propertyId, unit } = action.payload;
        if (!state.byProperty[propertyId]) state.byProperty[propertyId] = [];
        state.byProperty[propertyId].push(unit);
      })
      .addCase(updateUnit.fulfilled, (state, action) => {
        const updated = action.payload;
        for (let propId in state.byProperty) {
          const index = state.byProperty[propId].findIndex((u) => u.id === updated.id);
          if (index >= 0) {
            state.byProperty[propId][index] = updated;
            break;
          }
        }
      })
      .addCase(deleteUnit.fulfilled, (state, action) => {
        const { propertyId, id } = action.payload;
        state.byProperty[propertyId] = state.byProperty[propertyId].filter((u) => u.id !== id);
      });
  },
});

export default unitSlice.reducer;
